import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col bg-gray-100 antialiased" }
const _hoisted_2 = { class: "flex w-full min-h-screen" }
const _hoisted_3 = { class: "w-1/3 relative hidden lg:block" }
const _hoisted_4 = { class: "fixed top-0 left-0 w-1/3 h-screen flex flex-col justify-center items-start bg-white px-8 py-10 lg:px-10" }
const _hoisted_5 = { class: "max-w-xs mx-auto" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "block h-12 mb-10",
  src: "/media/logos/logo-full-dark.svg",
  alt: "Workflow"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", { class: "text-2xl leading-8 font-bold text-gray-900" }, "Your path to closing more loans", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-sm leading-5 font-normal text-gray-500 mt-2" }, " We look forward to sending you deals inside platform! ", -1)
const _hoisted_9 = {
  "aria-label": "Progress",
  class: "mt-6"
}
const _hoisted_10 = {
  role: "list",
  class: "overflow-hidden"
}
const _hoisted_11 = { class: "h-9 flex items-center" }
const _hoisted_12 = {
  key: 0,
  class: "relative z-10 w-8 h-8 flex items-center justify-center bg-sky rounded-full group-hover:bg-indigo-800"
}
const _hoisted_13 = {
  key: 1,
  class: "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-sky rounded-full"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "h-2.5 w-2.5 bg-sky rounded-full" }, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 2,
  class: "relative z-10 w-8 h-8 flex items-center justify-center bg-white border-2 border-gray-300 rounded-full group-hover:border-gray-400"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "h-2.5 w-2.5 bg-transparent rounded-full group-hover:bg-gray-300" }, null, -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "ml-4 min-w-0 flex flex-col" }
const _hoisted_20 = { class: "text-sm text-gray-500" }
const _hoisted_21 = { class: "w-full lg:w-2/3 flex h-full min-h-screen items-center justify-center px-6 lg:px-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckIcon = _resolveComponent("CheckIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("nav", _hoisted_9, [
              _createElementVNode("ol", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nav, ({ title, subtitle, key }, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    class: _normalizeClass(["relative", { 'pb-10': index < _ctx.nav.length - 1 }])
                  }, [
                    (index < _ctx.nav.length - 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(["-ml-px absolute mt-0.5 top-4 left-4 w-0.5 h-full", { 'bg-sky': _ctx.stepCompleted(key), 'bg-gray-300': !_ctx.stepCompleted(key) }]),
                          "aria-hidden": "true"
                        }, null, 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("a", {
                      href: "#",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                      class: "relative flex items-start group"
                    }, [
                      _createElementVNode("span", _hoisted_11, [
                        (_ctx.stepCompleted(key))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                              _createVNode(_component_CheckIcon, { class: "w-5 h-5 text-white" })
                            ]))
                          : (_ctx.stepActive(key))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_15))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, _hoisted_18))
                      ]),
                      _createElementVNode("span", _hoisted_19, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["text-xs font-semibold tracking-wide uppercase", { 'text-sky': _ctx.stepCompleted(key) || _ctx.stepActive(key), 'text-gray-600': !_ctx.stepCompleted(key) && !_ctx.stepActive(key) }])
                        }, _toDisplayString(title), 3),
                        _createElementVNode("span", _hoisted_20, _toDisplayString(subtitle), 1)
                      ])
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.step), {
          onNextStep: _ctx.handleNextStep,
          company: _ctx.company
        }, null, 40, ["onNextStep", "company"]))
      ])
    ])
  ]))
}